import React, { useEffect } from 'react'
import './Affichage.css'
import { Outlet, useOutletContext } from 'react-router-dom'
import { Drawer } from '@mui/material'
import { Box } from '@mui/system'
import { MenuPrincipal } from '../MenuPrincipal/MenuPrincipal'
import { Abonnement, OptionsAbonnement } from '../../../../Models/Abonnement/AbonnementModels'
import { Flux } from '../../../../Models/Message/MessageModels'
import { TypeMagasin } from '../../../../Models/Magasin/MagasinModels'

export interface propsAffichageUser{
  mobileOpen:boolean, handleDrawerClose:()=>void, handleDrawerTransitionEnd:()=>void
}

const drawerWidth = 300;

export function AffichageUser(props:propsAffichageUser) {

  const {mobileOpen, handleDrawerClose, handleDrawerTransitionEnd}=props;
  
  const contextDonnees = useOutletContext<any[]>(); 
  const abonnementsContext:Abonnement[] = contextDonnees[0];
  const fluxesContext:Flux[] = contextDonnees[1];
  const optionsAbonnementsContext:OptionsAbonnement[] = contextDonnees[2];
  const obtentionDonnees:()=>Promise<void> = contextDonnees[3];
  const typesMagasinContext:TypeMagasin[] = contextDonnees[4];

  return (
    <Box sx={{display:'flex', flex:1}}>
      <Box
        id="drawer-container"
        bgcolor="white"
        component="div"
      >
        <Box
          component="div"
          sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
          aria-label="menu"
        >
          <Drawer
              variant="temporary"
              open={mobileOpen}
              onTransitionEnd={handleDrawerTransitionEnd}
              onClose={handleDrawerClose}
              slotProps={{
                paper:{
                  style:{position:'absolute'}
                },
                backdrop:{style: { position: 'absolute' }},
                root: {
                  style: { position: 'absolute' },
                  container:document.getElementById('drawer-container'),
                  keepMounted: true, // Better open performance on mobile.
                },
              }}
              sx={{
                display: { xs: 'block', sm: 'none' },
                '& .MuiDrawer-paper': {
                  boxSizing: 'border-box',
                  width: drawerWidth,
                },
              }}
            >
              <MenuPrincipal
                abonnementsUtilisateur={abonnementsContext}
                typesMagasinsUser={typesMagasinContext}
              />
          </Drawer>
          <Drawer
            variant="permanent"
            sx={{
              display: { xs: 'none', sm: 'block' },
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
            }}
            open
            slotProps={{
              paper:{
                style:{position:'absolute'}
              },
              backdrop:{style: { position: 'absolute' }},
              root: {
                style: { position: 'absolute' },
                container:document.getElementById('drawer-container'),
                keepMounted: true, // Better open performance on mobile.
              },
            }}
          >
            <MenuPrincipal
              abonnementsUtilisateur={abonnementsContext}
              typesMagasinsUser={typesMagasinContext}
            />
          </Drawer>
        </Box>
      </Box>
      <Box
        className='boxOutlet'
      >
          <Outlet context={[abonnementsContext, fluxesContext, optionsAbonnementsContext, obtentionDonnees, typesMagasinContext]}/>
      </Box>
    </Box>
  )
}